import "@/App.css";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Contexts
import { ThemeProvider } from "./contexts/ThemeContext";
import { BionicReadingProvider } from "./contexts/BionicReadingContext";
import { AuthProvider } from "./contexts/AuthContext";

// Components
import { Navbar } from "./components/custom/Navbar";

// Pages
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import DietBuilder from "./pages/DietBuilder";
import MealPlan from "./pages/MealPlan";
import GroceryList from "./pages/GroceryList";
import Settings from "./pages/Settings";

// Layout wrapper for pages with navbar
const Layout = ({ children }) => {
  const location = useLocation();
  const hideNavbar = location.pathname === '/auth/verify';

  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      {!hideNavbar && <Navbar />}
      <div id="main-content">
        {children}
      </div>
    </>
  );
};

function AppRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/auth/verify" element={<AuthPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/diet-builder" element={<DietBuilder />} />
        <Route path="/meal-plan/:planId" element={<MealPlan />} />
        <Route path="/grocery-list" element={<GroceryList />} />
        <Route path="/grocery-list/:planId" element={<GroceryList />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BionicReadingProvider>
        <AuthProvider>
          <HashRouter>
            <AppRoutes />
            <Toaster position="top-right" richColors closeButton />
          </HashRouter>
        </AuthProvider>
      </BionicReadingProvider>
    </ThemeProvider>
  );
}

export default App;
